module.exports = __webpack_public_path__ + "static/media/fotogalereya15.18361f3e.jpg";